module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "modal_wrapper1"
    }
  }, [_c('section', {
    staticClass: "modal_window"
  }, [_c('div', {
    staticClass: "title clearfix"
  }, [_c('span', {
    staticClass: "title_content color_6 pull-left"
  }, [_vm._v(_vm._s(_vm.title))]), _vm._v(" "), _c('i', {
    staticClass: "glyphicon icon_off pull-right cursor",
    on: {
      "click": _vm.modalOff
    }
  }, [_vm._v("x")])]), _vm._v(" "), _c('div', {
    staticClass: "modal_main"
  }, [_c('router-link', {
    staticClass: "hidden",
    attrs: {
      "id": "defaultClick",
      "to": _vm.linkSrc
    }
  }), _vm._v(" "), _c('router-view')], 1)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@11.3.4@vue-loader/lib/template-compiler?{"id":"data-v-5b44197f"}!./~/_vue-loader@11.3.4@vue-loader/lib/selector.js?type=template&index=0!./src/components/agreement_modal.vue
// module id = 1263
// module chunks = 1